function toggle_active(elt, tableId, api_base) {
  const table = $('#' + tableId).DataTable();
  const cell = table.cell($(elt).parent());
  const row_index = cell.index()['row'];
  const row_data = cell.row(row_index).data();

  $.ajax({
    'url': api_base + '/' + row_data.id + '.json',
    'type': 'PUT',
    'data': {
      id: row_data.id,
      active: !cell.data()
    },
    'success': function (data, status) {
      cell.data(!cell.data()).draw();
    }
  });
}

function iter(o) {
  Object.keys(o).forEach(function (k) {
    if (o[k] !== null && typeof o[k] === 'object') {
      iter(o[k]);
      return;
    }
    if (typeof o[k] === 'string') {
      o[k] = $.fn.dataTable.render.text().display(o[k]);
    }
  });
}

globalThis.dataTableSafeData = function (object) {
  // proxy object is not working with cell.data(is_active).draw();
  // as result I ended up iterating over all fields and escaping html
  //
  // RPR-6314: escape a COPY. This used to escape in place and hand back the same reference, and
  // the escaper is not idempotent (it rewrites & -> &amp; unconditionally), so any caller that ran
  // the same array through twice compounded 'A & B' -> 'A &amp; B' -> 'A &amp;amp; B'. Callers
  // must therefore use the return value; passing an array in and then reading the original is no
  // longer enough to get escaped data.
  const escaped = angular.copy(object);
  iter(escaped);
  return escaped;
};

// Decodes entities without running markup; the result may be raw HTML, so sanitize it before inserting.
globalThis.htmlToText = function (html) {
  return new DOMParser().parseFromString(html ?? '', 'text/html').body.textContent;
};

// Turns a dataTableSafeData-escaped rich-text value back into sanitized HTML for a display cell.
globalThis.escapedHtmlToSafeHtml = function (escapedHtml, sanitize) {
  return sanitize(globalThis.htmlToText(escapedHtml));
};

globalThis.dataTableAjaxSafeDataFilter = function (data, type) {
  return JSON.stringify(globalThis.dataTableSafeData(JSON.parse(data)));
};

// Chrome works without this (as well as with this), but Firefox requires it to display the buttons
if ($.trumbowyg) {
  $.trumbowyg.svgPath = '../lib/thirdparty/trumbowyg/icons.svg';
}

// Allow 'style' attribute in ng-bind-html but restrict to whitelisted CSS properties only.
// This is needed for the Trumbowyg foreColor plugin (text color) and its alignment buttons (text-align).
app.config(['$provide', '$sanitizeProvider', function ($provide, $sanitizeProvider) {
  const allowedCssProperties = new Set(['color', 'text-align']);

  $sanitizeProvider.addValidAttrs(['style']);

  $provide.decorator('$sanitize', ['$delegate', function ($delegate) {
    return function (html) {
      const sanitized = $delegate(html);
      const div = document.createElement('div');
      div.innerHTML = sanitized;
      const elements = div.querySelectorAll('[style]');
      for (const el of elements) {
        const filteredStyles = [];
        for (const prop of el.style) {
          if (allowedCssProperties.has(prop)) {
            filteredStyles.push(prop + ': ' + el.style.getPropertyValue(prop));
          }
        }
        if (filteredStyles.length) {
          el.setAttribute('style', filteredStyles.join('; ') + ';');
        } else {
          el.removeAttribute('style');
        }
      }
      return div.innerHTML;
    };
  }]);
}]);

// RPR-6314: forward uncaught Angular exceptions to Sentry.
//
// Angular routes every uncaught digest / $timeout / directive exception to $exceptionHandler,
// whose default implementation is $log.error - i.e. the browser console and nowhere else.
// portal/js/sentry.js initialises the SDK, but nothing in the portal ever called
// captureException and there is no captureConsoleIntegration, so these throws were invisible in
// production. Sentry's own browserApiErrors wrapper cannot help either, because Angular catches
// first and nothing escapes for it to see.
//
// Chained rather than replaced, so the console behaviour developers rely on is unchanged. Sentry
// is loaded before this file on all seven entry pages (vendor-env.js -> the SDK bundle ->
// js/sentry.js -> routing -> app_common.js), and a blank DSN makes the SDK a no-op by itself, so
// no environment gate is needed here.
app.config(['$provide', function ($provide) {
  $provide.decorator('$exceptionHandler', ['$delegate', function ($delegate) {
    return function (exception, cause) {
      if (globalThis.Sentry) {
        globalThis.Sentry.captureException(exception, {extra: {cause: cause}});
      }
      $delegate(exception, cause);
    };
  }]);
}]);

function initToastrOptions() {
  // Toastr settings
  $(document).ready(function () {
    if (typeof toastr == 'undefined') {
      globalThis.toastr = {};
    }

    toastr.options = {
      'closeButton': true,
      'debug': false,
      'newestOnTop': false,
      'progressBar': true,
      'positionClass': 'toast-bottom-full-width',
      'preventDuplicates': false,
      'onclick': null,
      'showDuration': '300',
      'hideDuration': '1000',
      'timeOut': '5000',
      'extendedTimeOut': '1000',
      'showEasing': 'swing',
      'hideEasing': 'linear',
      'showMethod': 'fadeIn',
      'hideMethod': 'fadeOut'
    };
  });
}

// Init Toastr Options
initToastrOptions();

function initDataTablesDefaults() {
  $(document).ready(function () {
    if ($.fn.dataTable != undefined) {
      $.extend(true, $.fn.dataTable.defaults, {
        language: {
          search: '<i class="fa fa-search"></i>',
          searchPlaceholder: 'search',
          paginate: {
            previous: '<i class="fa fa-angle-left"></i>',
            next: '<i class="fa fa-angle-right"></i>',
            first: '<i class="fa fa-angle-double-left"></i>',
            last: '<i class="fa fa-angle-double-right"></i>'
          }
        }
      });
    }
  });
}

// Init Data Table Default Params
initDataTablesDefaults();

function toggle_wrapper(elt, id, active) {
  const eltScope = angular.element(elt).scope();
  eltScope.toggle(elt, id, active);
}

function datatables_action_wrapper(elt, scope_fn_name, data) {
  const eltScope = angular.element(elt).scope();
  eltScope[scope_fn_name](elt, data);
}

// eslint-disable-next-line no-redeclare
function preventDataTableMenuClipping() {
  // Add padding to make sure the drop down menu (if exists), does not get clipped
  const dtWrappers = $('.dt-container');
  if (dtWrappers != null) {
    dtWrappers.each(function (index, dTable) {
      if ($($(dTable).find('.mat.ui.dropdown-menu')) != null &&
        $($(dTable).find('.mat.ui.dropdown-menu')[0]).find('li') != null) {
        const len = $($(dTable).find('.mat.ui.dropdown-menu')[0]).find('li').length;
        const padding = ((len * 25) + 50) + 'px';
        $(dTable).css('padding-bottom', padding);
      }
    });
  }
}

// Load up the drop down menu
$(document).ready(function () {
  $('html').click(function () {
    $('.menu-item.drop-down-menu-item').removeClass('drop-down--active');
  });
});

function showMainHeaderMenu(elem, event) {
  $('.menu-item.drop-down-menu-item').removeClass('drop-down--active');

  event.stopPropagation();

  const parent = $(elem).parent();
  parent.addClass('drop-down--active');

  // If this menu contains a ui-select, stop event propagation on it
  if ($(parent).find('.drop-down-menu-box .search-box').length > 0) {
    $(parent).find('.drop-down-menu-box .search-box').off('click').on('click', function (event) {
      event.stopPropagation();
    });
  }
}

function stopEventPropagation() {
  event.stopPropagation();
}

// Works only on 'click' events
function copyToClipboard(str) {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  const selected = document.getSelection().rangeCount > 0
    ? document.getSelection().getRangeAt(0)
    : false;

  el.select();
  document.execCommand('copy');      // Copy - only works as a result of a user action (e.g. click events)
  document.body.removeChild(el);

  if (selected) {                                 // If a selection existed before copying
    document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
    document.getSelection().addRange(selected);   // Restore the original selection
  }

  if (typeof toastr != 'undefined') {
    toastr['success']('The data was copied to the clipboard successfully.');
  }
}

// Strips one layer of {{ ... }} pairs from a string (S5852: no regex to avoid backtracking)
function stripDoubleBracePairs(str) {
  const parts = [];
  let i = 0;
  while (i < str.length) {
    if (i < str.length - 1 && str[i] === '{' && str[i + 1] === '{') {
      const endIdx = str.indexOf('}}', i + 2);
      if (endIdx === -1) {
        parts.push(str.slice(i));
        break;
      } else {
        parts.push(str.substring(i + 2, endIdx));
        i = endIdx + 2;
      }
    } else {
      const nextOpen = str.indexOf('{{', i);
      if (nextOpen === -1) {
        parts.push(str.substring(i));
        i = str.length;
      } else {
        parts.push(str.substring(i, nextOpen));
        i = nextOpen;
      }
    }
  }
  return parts.join('');
}

// Function to remove properly paired curly braces recursively
// This is helpful to sanitize data for CSTI attacks
function removeCurlyBraces(str) {
  let previous;
  const MAX_ITERATIONS = 100;
  let iterations = 0;
  do {
    previous = str;
    str = stripDoubleBracePairs(str);
    iterations++;
  } while (str !== previous && iterations < MAX_ITERATIONS);
  if (iterations >= MAX_ITERATIONS) {
    // Fail safe: strip all curly braces to prevent any possible template injection
    str = str.replaceAll('{', '').replaceAll('}', '');
  }
  return str;
}

// Utility function to sanitize data
function sanitizeDataForCSTI(data) {
  if (typeof data === 'object' && data !== null) {
    if (data instanceof FormData) {
      const sanitizedFormData = new FormData();
      for (let [key, value] of data.entries()) {
        if (typeof value === 'string') {
          value = removeCurlyBraces(value);
        }
        else if (value instanceof File) {
          sanitizedFormData.append(key, value);
          continue;
        }
        else if (typeof value === 'object') {
          value = sanitizeDataForCSTI(value);
        }
        sanitizedFormData.append(key, value);
      }
      return sanitizedFormData;
    } else {
      let jsonString = JSON.stringify(data);
      if (!jsonString.includes('{{') || !jsonString.includes('}}')) {
        return data;
      }
      jsonString = removeCurlyBraces(jsonString);
      try {
        return JSON.parse(jsonString);
      }
      catch (e) {
        console.info('>>>>>>>>>>>>>>>>>>>>>>>>>>>>Error parsing JSON data: ', e); // eslint-disable-line no-console
        return data;
      }
    }
  }
  return data;
}

const cstiRequestInterceptor = function ($q) {
  return {
    request: function(config) {
      if (config.data && config.method.toUpperCase() !== 'GET') {
        config.data = sanitizeDataForCSTI(config.data);
      }
      return config;
    },
    requestError: function(rejection) {
      return $q.reject(rejection);
    }
  };
};

const cstiResponseInterceptor = function ($q) {
  return {
    response: function(response) {
      if (response.data) {
        response.data = sanitizeDataForCSTI(response.data);
      }
      return response;
    },
    responseError: function(rejection) {
      return $q.reject(rejection);
    }
  };
};

app.config(['$httpProvider',  '$locationProvider', '$compileProvider', 'SETTINGS',
  function ($httpProvider,  $locationProvider, $compileProvider, SETTINGS) {

    // Can we replace this with $cookie of angularjs ?
    const getCookie = function(cname) {
      const name = cname + '=';
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    };

    const getCSRFCookieName = function () {
      if (SETTINGS.COOKIE_PREFIX) {
        return SETTINGS.COOKIE_PREFIX + 'csrftoken';
      }
      else {
        return 'csrftoken';
      }
    };

    const csrfInterceptor = function ($q) {
      return {
        request: function (config)
        {
          // Anything added here will execute before request is sent to the server
          if (config.method !== 'GET') {
            const csrftoken = getCookie(getCSRFCookieName());
            config.headers['X-CSRFtoken'] = csrftoken;
          }
          return config;
        }
      };
    };


    //initialize get if not there
    $httpProvider.defaults.withCredentials = true;

    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
    }

    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|javascript):/);

    // set hash-prefix to empty string ('')
    $locationProvider.hashPrefix('');

    //disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

    $httpProvider.interceptors.push(csrfInterceptor);
    // Inject CSTI handler interceptor
    $httpProvider.interceptors.push(cstiRequestInterceptor);
    $httpProvider.interceptors.push(cstiResponseInterceptor);
  }]);

// RPR-6334. A Cache API failure is a caching problem, not a data problem -- the response is still
// perfectly fetchable over HTTP -- so every one of them below falls back to the network instead of
// rejecting. None of them did before: a rejected caches.open (Firefox private browsing, blocked
// site data, a quota error, a corrupt quota-manager profile) reached handle403, which rethrows
// anything that is not the exact 403 detail string, and surfaced to the user as a "Something went
// wrong" dialog on a screen whose data was fine.
//
// CACHE_SUPPORTED inside the factory stays, and is not made redundant by any of this: it guards
// `caches` being absent altogether, which is a synchronous ReferenceError rather than a rejection
// and so is not something these handlers could catch.
//
// Only the cache machinery is caught here. A rejection from $http is a real transport or HTTP
// failure and propagates untouched to handle403, exactly as on the uncached path.
//
// These three live at module scope, outside the factory, because none of them closes over
// anything the factory provides (Sonar S7721). The httpAuth prefix is not decoration: the legacy
// portal concatenates every file into one shared top-level scope, where two same-named
// declarations merge silently and the last one loaded wins. `reportCacheProblem` is exactly the
// kind of name a second file would pick. Same convention as phReportCaughtError and friends in
// portal_helper.js.
//
// Wrapped, like its counterparts in portal_helper.js. This is called from inside $http's SUCCESS
// handler (via httpAuthPutInCache) as well as from the rejection handlers, so a throwing Sentry --
// a partially-initialised SDK, a beforeSend that raises -- would escape into the .then callback,
// reject a request that had already returned 200 with its data in hand, and put the very dialog
// this ticket removes back on screen, blaming the wrong subsystem.
const httpAuthReportCacheProblem = function (message, error_) {
  try {
    console.warn('HttpAuth mat-cache: ' + message, error_); // eslint-disable-line no-console
    if (typeof globalThis.Sentry?.captureException === 'function') {
      globalThis.Sentry.captureException(error_, {extra: {reason: message}});
    }
  } catch (reportingError) {
    // Reporting a cache problem must never be able to fail the request the cache was only
    // trying to make faster.
    console.warn('HttpAuth mat-cache: could not report a problem', reportingError); // eslint-disable-line no-console
  }
};

// Fire-and-forget: the caller already holds its response and must neither wait on, nor fail for, a
// write that is only an optimisation. The rejection is caught all the same -- a QuotaExceededError
// here used to become an unhandled NATIVE rejection, picked up if at all by Sentry's global
// unhandledrejection handler with nothing to say it came from the cache. Note that is not the
// $q -> $exceptionHandler route the decorator at the top of this file serves: the Cache API
// returns native promises, which Angular never sees.
const httpAuthPutInCache = function (cache, url, response) {
  try {
    cache.put(url,
      new Response(
        JSON.stringify(response),
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
    ).catch(function (error_) {
      httpAuthReportCacheProblem('could not write ' + url, error_);
    });
  } catch (error_) {
    // Covers the whole call, not just the serialisation: JSON.stringify (a circular ref reachable
    // from response.config is the realistic case) and the Response constructor both throw
    // synchronously rather than rejecting, and a shimmed cache.put could too.
    httpAuthReportCacheProblem('could not write ' + url + ' (threw)', error_);
  }
};

// The read half, taking the refetch as a parameter rather than closing over it. Split out of
// getCachedResponse so the poisoned-entry .catch is not a fifth level of nesting (Sonar S2004),
// which is also where it stopped being readable.
const httpAuthReadFromCache = function (cache, url, fetchAndCache) {
  return cache.match(url).then(
    function (cached) {
      if (!cached) {
        return fetchAndCache(cache);
      }
      return cached.json().catch(function (error_) {
        // A body that will not parse is a poisoned entry -- half-written, or written by a build
        // that shaped it differently. Deliberately NOT deleted: fetchAndCache overwrites it
        // through cache.put, and an explicit delete racing that put could remove the fresh entry
        // it had just written.
        httpAuthReportCacheProblem('cached entry for ' + url + ' would not parse; refetching', error_);
        return fetchAndCache(cache);
      });
    },
    function (error_) {
      httpAuthReportCacheProblem('cache.match failed for ' + url, error_);
      return fetchAndCache(cache);
    }
  );
};

app.factory('HttpAuth',
  ['$http', 'authHelper',
    function ($http, authHelper) {
      const serviceObj = {};
      const CACHE_SUPPORTED = 'caches' in window;

      function getAugmentedConfig(cfg) {
        const config = cfg || {};
        const useOrigLogin = !!(config.skip_impersonation);

        config.headers = config.headers || {};

        return config;
      }

      /**
      * @param {*} url This is the url whose response we are going to catch
      * @param {*} config configuration object for $http
      * @param {*} method API method
      * @returns a promise which will resolve to cached response if available. Otherwise, you'll get a promise to simple API call
      */
      const getCachedResponse = function (url, config, method) {
        // cache is null when the store could not be opened at all, which only costs the write.
        const fetchAndCache = function (cache) {
          return $http[method](url, config).then(function (response) {
            if (cache) {
              httpAuthPutInCache(cache, url, response);
            }
            return response;
          });
        };

        return caches.open('mat-cache').then(
          function (cache) {
            return httpAuthReadFromCache(cache, url, fetchAndCache);
          },
          function (error_) {
            httpAuthReportCacheProblem('caches.open failed', error_);
            return fetchAndCache(null);
          }
        );
      };

      function handle403(response) {
        if (403 === response.status && response.data && response.data.detail === 'Authentication credentials were not provided.') {
          const addReturnUrl = true;
          authHelper.doLogoutAll(addReturnUrl);
        } else {
          throw response;
        }
      }

      ['delete', 'get', 'head', 'jsonp'].forEach(function (method) {
        serviceObj[method] = function (url, config, useCacheApis) {
          const isMaintenanceUrl = url.indexOf('maintenance_window.json') != -1;
          if (!isMaintenanceUrl) {
            config = getAugmentedConfig(config);
          }

          let apiPromise;
          if (useCacheApis && CACHE_SUPPORTED) {
            apiPromise = getCachedResponse(url, config, method);
          }
          else {
            apiPromise = $http[method](url, config);
          }

          return apiPromise.then(null, handle403);
        };
      });

      ['post', 'put', 'patch'].forEach(function (method) {
        serviceObj[method] = function (url, data, config) {
          config = getAugmentedConfig(config);
          return $http[method](url, data, config).then(null, handle403);
        };
      });

      return serviceObj;
    }]);

// eslint-disable-next-line no-redeclare
const ACTIVE = '__A__';
// eslint-disable-next-line no-redeclare
const INACTIVE = '__I__';

function startTut(hint_number) {
  introJs().setOption('overlayOpacity', 0.2);

  if (hint_number == 1) {
    introJs().start();
  } else {
    introJs().goToStepNumber(hint_number).start();
  }
}

function allowOneDecimalPlace(field, event) {
  setTimeout(function () {
    const regex = /\d*\.?\d?/g;
    field.value = regex.exec(field.value);
  }, 100);
}
